/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type AccordionItemElementElementModelContentType = typeof AccordionItemElementElementModelContentType[keyof typeof AccordionItemElementElementModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccordionItemElementElementModelContentType = {
  accordionItemElement: 'accordionItemElement',
} as const;
